import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import { createElement } from 'react';
import rehypeHighlight from 'rehype-highlight';
import rehype2react from 'rehype-react';
import Doc from 'unified-doc';
import visit from 'unist-util-visit';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p><a parentName="p" {...{
        "href": "https://github.com/rehypejs/rehype"
      }}>{`rehype`}</a>{` plugins can be used by `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{` to enhance the rendered document.  `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{` uses a number of private plugins to implement its core APIs.  Plugins can be applied as `}<inlineCode parentName="p">{`prePlugins`}</inlineCode>{` or `}<inlineCode parentName="p">{`postPlugins`}</inlineCode>{`, which correspond to whether the plugins are run before/after private plugins are applied.  Plugins should use the `}<inlineCode parentName="p">{`PluggableList`}</inlineCode>{` interface e.g. `}<inlineCode parentName="p">{`[plugin1, [plugin2, plugin2Options]]`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "preplugins"
    }}><inlineCode parentName="h3">{`prePlugins`}</inlineCode></h3>
    <p>{`These plugins are applied `}<strong parentName="p">{`before`}</strong>{` private plugins, and therefore API methods (e.g. `}<inlineCode parentName="p">{`marks`}</inlineCode>{`) can act on the changes made by these plugins, as seen in the example below where the `}<inlineCode parentName="p">{`marks`}</inlineCode>{` algorithm is able to operate on changes made by the `}<inlineCode parentName="p">{`rehype-highlight`}</inlineCode>{` plugin.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "live=true",
        "live": "true"
      }}>{`// import { createElement } from 'react';
// import rehypeHighlight from 'rehype-highlight';
// import rehype2react from 'rehype-react';
// import Doc from 'unified-doc';

function() {
  const doc = Doc({
    compiler: [[rehype2react, { createElement }]],
    content: \`
      function greet() {
        return "hello world";
      }\`,
    filename: 'doc.js',
    marks: [{ id: 'a', start: 16, end: 21 }],
    prePlugins: [[rehypeHighlight, { ignoreMissing: true }]],
    sanitizeSchema: null,
  });
  return (
    <div>
      <h4>Compiled</h4>
      {doc.compile().result}
      <h4>HTML</h4>
      <pre>{doc.file('.html').content}</pre>
    </div>
  );
}
`}</code></pre>
    <h3 {...{
      "id": "postplugins"
    }}><inlineCode parentName="h3">{`postPlugins`}</inlineCode></h3>
    <p>{`Unlike `}<inlineCode parentName="p">{`prePlugins`}</inlineCode>{`, these plugins are applied `}<strong parentName="p">{`after`}</strong>{` private plugins, and therefore API methods (e.g. `}<inlineCode parentName="p">{`marks`}</inlineCode>{`) do not act on changes made by these plugins (since they are applied later), as seen in the example below where the `}<inlineCode parentName="p">{`marks`}</inlineCode>{` algorithm doesn't run on the changes made by `}<inlineCode parentName="p">{`rehype-plugins`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "live=true",
        "live": "true"
      }}>{`// import { createElement } from 'react';
// import rehypeHighlight from 'rehype-highlight';
// import rehype2react from 'rehype-react';
// import Doc from 'unified-doc';

function() {
  const doc = Doc({
    compiler: [[rehype2react, { createElement }]],
    content: \`
      function greet() {
        return "hello world";
      }\`,
    filename: 'doc.js',
    marks: [{ id: 'a', start: 16, end: 21 }],
    postPlugins: [[rehypeHighlight, { ignoreMissing: true }]],
    sanitizeSchema: null,
  });
  return (
    <div>
      <h4>Compiled</h4>
      {doc.compile().result}
      <h4>HTML</h4>
      <pre>{doc.file('.html').content}</pre>
    </div>
  );
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Use `}<inlineCode parentName="p">{`postPlugins`}</inlineCode>{` with care because some plugins might strictly overwrite any changes made by prviate plugins.`}</p>
    </blockquote>
    <h3 {...{
      "id": "custom-plugins"
    }}>{`Custom plugins`}</h3>
    <p>{`Here is an example of a custom plugin that capitalizes all text node values, and applied as a `}<inlineCode parentName="p">{`prePlugin`}</inlineCode>{` so private plugins can pickup changes applied by it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "live=true",
        "live": "true"
      }}>{`// import { createElement } from 'react';
// import rehype2react from 'rehype-react';
// import Doc from 'unified-doc';
// import visit from 'unist-util-visit';

function() {
  function customPlugin() {
    return function transformer(tree) {
      visit(tree, 'text', (node) => {
        node.value = node.value.toUpperCase();
      });
      return tree;
    }
  }

  const doc = Doc({
    compiler: [[rehype2react, { createElement }]],
    content: '> **some** markdown content',
    filename: 'doc.md',
    marks: [{ id: 'a', start: 6, end: 14 }],
    prePlugins: [[customPlugin]],
    sanitizeSchema: null,
  });

  return (
    <div>
      <h4>Compiled</h4>
      {doc.compile().result}
      <h4>HTML</h4>
      <pre>{doc.file('.html').content}</pre>
    </div>
  );
}
`}</code></pre>
    {
      /* Definitions */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      